export default {
  last24hours: "最近24h",
  today: "今天",
  yesterday: "昨天",
  lastThreeDays: "最近三天",
  lastSevenDays: "最近七天",
  complaintStats: "客诉统计",
  tagStats: "标签统计",
  conversationStats: "24h会话统计",
  kfStat: "客服监控",
  ratingStatistics: "评分统计",
  closedConversations: "已关闭数",
  openConversations: "未关闭数",
  closedIssues: "关闭问题数",
  ratingCount: "评分数",
  averageScore: "平均得分",
  serviceStatus: "客服状态",
  unclosedConversations: "未关闭对话数",
  unreadConversations: "未读对话数",
  conversationStatistics24h: "24h会话统计",
  employeeID: "员工id",
  date: "日期",
  datePlaceholder: "请选择日期",
  day: "统计日期",
  assignCnt: "总分配任务数",
  finishedCnt: "已完成任务数",
  loginCnt: "重新登录数",
  rechargeCnt: "复充人数",
  calledCnt: "呼叫数",
  connectedCnt: "接通数",
  claimedCnt: "礼物码领取人数",
};
